// Angular Imports
import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router'
// Shared Imports
import { ERoles } from '@shared/models'
// Store Imports
import { Store } from '@ngrx/store'
import { selectUserRoles } from '@store/selectors'
// Thirdparty Imports
import { map, take } from 'rxjs'

export const hasRolesGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const _router = inject(Router)
	const _store = inject(Store)

	const checkUserRoles = ({ rolesToVerify }: CheckUserRoles): boolean => {
		// We check if the received roles exist in the roles allowed for this user
		const allowedRoles: ERoles[] =
			(route && route.data['allowedRoles']) ?? route.data['allowedRoles']
		const atLeastOne = allowedRoles.some((role: ERoles) => rolesToVerify.includes(role))
		if (atLeastOne) {
			// console.log('[ROLES] Role Permission Granted')
			return true
		} else {
			// console.log('[ROLES] Role Permission Denied')
			_router.navigate(['/dashboard'])
			return false
		}
	}

	return _store.select(selectUserRoles).pipe(
		take(1),
		map((roles: ERoles[]) => checkUserRoles({ rolesToVerify: roles }))
	)
}

interface CheckUserRoles {
	rolesToVerify: ERoles[]
}
